import Offcanvas from "bootstrap/js/dist/offcanvas";

const OpenAds = () => {
  const openAdsDrawer = () => {
    const el = document.getElementById("offcanvasRight");

    if (el) {
      const offcanvas = new Offcanvas(el);
      offcanvas.show();
    }
  };

  return (
    <div>
      <div
        className={"td_openads td_openads_show"}
        onClick={openAdsDrawer}
        style={{ paddingLeft: "3px" }}
      >
        <i className="fa-solid fa-play"></i>
      </div>
    </div>
  );
};

export default OpenAds;
